import api from "@/services/axios";

export type TenantBranding = {
  tenantId: string;
  name: string;
  code: string;
  email: string;
  phoneNumber?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
  logoUrl?: string;
  faviconUrl?: string;
  board?: string;
  timeZoneId?: string;
  countryCode?: string;
  currencyCode?: string;
  callingCode?: string;
  locale?: string;
};

type ApiResponse<T> = {
  data?: T;
  success?: boolean;
  message?: string;
  errors?: Array<{ message?: string | null }> | null;
};

type TenantBrandingApi = {
  id?: string;
  Id?: string;
  name?: string;
  Name?: string;
  code?: string;
  Code?: string;
  email?: string;
  Email?: string;
  phoneNumber?: string | null;
  PhoneNumber?: string | null;
  addressLine1?: string | null;
  AddressLine1?: string | null;
  addressLine2?: string | null;
  AddressLine2?: string | null;
  city?: string | null;
  City?: string | null;
  state?: string | null;
  State?: string | null;
  country?: string | null;
  Country?: string | null;
  postalCode?: string | null;
  PostalCode?: string | null;
  logoUrl?: string | null;
  LogoUrl?: string | null;
  faviconUrl?: string | null;
  FaviconUrl?: string | null;
  board?: string | null;
  Board?: string | null;
  timeZoneId?: string | null;
  TimeZoneId?: string | null;
  countryCode?: string | null;
  CountryCode?: string | null;
  currencyCode?: string | null;
  CurrencyCode?: string | null;
  callingCode?: string | null;
  CallingCode?: string | null;
  locale?: string | null;
  Locale?: string | null;
};

function unwrapApiResponse<T>(payload: ApiResponse<T>): T {
  if (payload?.success === false) {
    throw new Error(payload.message || "Request failed.");
  }

  const firstError = payload?.errors?.[0]?.message;
  if (firstError) {
    throw new Error(firstError);
  }

  if (payload?.data === undefined) {
    throw new Error(payload?.message || "Unexpected API response.");
  }

  return payload.data;
}

export async function getTenantBranding(): Promise<TenantBranding> {
  const response = await api.get<ApiResponse<TenantBrandingApi>>("/tenant/details");
  const raw = unwrapApiResponse(response.data);

  return {
    tenantId: raw.id ?? raw.Id ?? "",
    name: raw.name ?? raw.Name ?? "School",
    code: raw.code ?? raw.Code ?? "",
    email: raw.email ?? raw.Email ?? "",
    phoneNumber: raw.phoneNumber ?? raw.PhoneNumber ?? undefined,
    addressLine1: raw.addressLine1 ?? raw.AddressLine1 ?? undefined,
    addressLine2: raw.addressLine2 ?? raw.AddressLine2 ?? undefined,
    city: raw.city ?? raw.City ?? undefined,
    state: raw.state ?? raw.State ?? undefined,
    country: raw.country ?? raw.Country ?? undefined,
    postalCode: raw.postalCode ?? raw.PostalCode ?? undefined,
    logoUrl: raw.logoUrl ?? raw.LogoUrl ?? undefined,
    faviconUrl: raw.faviconUrl ?? raw.FaviconUrl ?? undefined,
    board: raw.board ?? raw.Board ?? undefined,
    timeZoneId: raw.timeZoneId ?? raw.TimeZoneId ?? undefined,
    countryCode: raw.countryCode ?? raw.CountryCode ?? undefined,
    currencyCode: raw.currencyCode ?? raw.CurrencyCode ?? undefined,
    callingCode: raw.callingCode ?? raw.CallingCode ?? undefined,
    locale: raw.locale ?? raw.Locale ?? undefined,
  };
}
